import gql from 'graphql-tag';

import { vendorPartial } from './VendorFragment';
import { VendorCampaignBase } from './VendorCampaignFragment';

const VendorLayerFragment = gql`
  fragment VendorLayerFragment on VendorLayer {
    __typename
    id
    layerID
    vendorID
    networkID
    brokerID
    description
    leadChannelDescription
    tags
    verticalType
    kindOfLead
    dupCheckLevelID
    addonPrice
    vendor {
      ${vendorPartial}
    }
    vendorCampaigns{
      ${VendorCampaignBase}
    }
    liveTransfersEnabled
    minimumRefresh
    autoProcessThreshold
    autoProcess
    vendorSourceCampaign
    mpVendorCampaignName
    vendorSourceCampaignMap
    vendorPrice
    maxDemandUnsoldAccepted
    splitCount
    enhanceProfile
    rejectDuplicates
    rejectDisconnected
    rejectDNC
    apiType    
    maxSpendPerHour
    maxSpend
    pingPostEnabled
    pingPostType
    fixedBidPrice
    legacySync
    rejectDuplicates
    pendingLeads
    legacySync
    errorLeads
    refundEligible
    isCampaignDestination
    skipActiveDemandSubmit
    overideDuplicateChecks
    allowMLOverride
    allowMLearning
    mlVersion{
      label
      value
    }
    smartPriceAcceptence
    splitStopActiveDemand
    splitStopCountMinActiveDemand
    splitActiveDemandFallBack{
      label
      value
    }
    dupPriceThreashold
    dupPriceThreasholdLookBack
    adIncomeMax
    adHouseHoldMax
    applyOverrideFilter
    agentProfileAssigmentAllowed
    allowMLOnSubmit
    allowAPOnPing
    overrideBlockedAttributeFields{
      label
      value
    }
    overrideBlockedValues{
      label
      value
    }
    crossNetworkLayers{
      label
      value
    }
    allowSlices
    allowSplits
    deactivateActiveDemand
    heyflowBotDetection
    nonusaBotDetection
    vendorPriceInPennies
    globalWildCardFilter
    rejectTresstle
    tresstleScoreMin
    crossNetworkSplit
    networkSplitKey{
      label
      value
    }
    minNetworkSplit
    maxNetworkSplit
    isUpdateEligible
    delaySecondsForUpdate
    mlTargetConversionRate
    mlProbablityIncreasePercentage
    mlProbablityIncreasePerLead
    mlBeforeThreashold
    allowAdvanceFitering
    doNotAcceptQualityRejects
    allowMLPriceOverride
    mlTargetMinPrice
    mlTargetMaxPrice
    minAcceptenceBid
    mlAggressionPriceLevel
    mlAggressionConversionLevel
    mlNetworkOptimized
    mlCPATarget
    useEventsMLModel
    filters{
        __typename
        ... on VendorLayerAddOnFilter{
         description
        }
        ... on VendorLayerVerifyFilter{
         description
        }
        ... on VendorLayerSystemFilter{
        description
        }
        ... on VendorLayerTimeFilter{
         description
        }
        ... on VendorLayerStaticFilter{
         description
        }
        ... on VendorLayerMultiFilter{
         description
        }
        ... on VendorLayerRangeFilter{
         description
        }
        ... on VendorLayerDynamicFilter {
         description
        }
    }
    apBidEnhancmentEnabled
    apSettings{
        apBidEnhancmentDynamic
        apPercentageEnabled
        apWPMMin
        apWPMMax
        apKPMMin
        apKPMMax
        apBidPrice
        apBidPercentage
    }
    cbNewAdmin
    newAgedUpload
  }
`;

export default VendorLayerFragment;
